import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface BadgeItem {
  icon: string;
  label: string;
  subLabel?: string;
}

const badges: BadgeItem[] = [
  {
    icon: 'ri-government-line',
    label: '대전가정법원',
    subLabel: '성년후견인 후보자',
  },
  {
    icon: 'ri-building-4-line',
    label: '대전지방법원',
    subLabel: '파산관재인',
  },
  {
    icon: 'ri-heart-pulse-line',
    label: '이혼전문변호사',
    subLabel: '심리적 동반자',
  },
  {
    icon: 'ri-user-star-line',
    label: '사법고시 출신',
    subLabel: '38기',
  },
];

export default function CredibilityBar() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative z-20 -mt-10 md:-mt-14 px-4 md:px-8">
      <div className="max-w-6xl mx-auto" ref={sectionRef}>
        <div
          className={`bg-background-50 rounded-xl border border-background-200/60 shadow-lg shadow-foreground-950/5 px-5 py-6 md:px-8 md:py-8 transition-all duration-700 ${
            visible
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 justify-items-center">
            {badges.map((badge, index) => (
              <div
                key={badge.label}
                className={`flex items-center gap-3 md:gap-4 transition-all duration-500 ${
                  visible
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-4'
                }`}
                style={{
                  transitionDelay: visible ? `${index * 120}ms` : '0ms',
                }}
              >
                <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className={`${badge.icon} text-base md:text-lg`}></i>
                </span>
                <div className="text-left">
                  <p className="text-xs md:text-sm font-semibold text-foreground-950 whitespace-nowrap">
                    {badge.label}
                  </p>
                  {badge.subLabel && (
                    <p className="text-[11px] md:text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
                      {badge.subLabel}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}